import apiCall from "../utils/apiCall";

export async function listLegalPages() {
  try {
    const response = await apiCall("/legal", "GET");
    if (!response.ok) return [];
    const payload = await response.json();
    const data = payload?.data ?? payload;
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

export async function getLegalPage(slug) {
  if (!slug) return null;
  try {
    const response = await apiCall(`/legal/${encodeURIComponent(slug)}`, "GET");
    if (!response.ok) return null;
    const payload = await response.json();
    return payload?.data ?? null;
  } catch {
    return null;
  }
}

export default { listLegalPages, getLegalPage };
